const { docToEntity } = require('./../../tools')

exports.listProgramsByIds = async function (state, programIds) {
  const doc = await state.dal.program.getProgramsByIds(state, programIds)
  return docToEntity(doc, false)
}
